

















































































import { SET_CURRENT_REACTIVATION_EMAIL_BLUEPRINT_ID } from '@/store/mutation-types';
import { SAVE_STATE } from '@/store/shared';
import { IEmail, IEmailBlueprint } from '@/store/types';
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'CampaignSequence',
  data() {
    return {
      SAVE_STATE,
    };
  },
  computed: {
    ...mapGetters(['currentReactivationCampaignBlueprintSaveState']),
    emails(): IEmailBlueprint[] {
      return this.$store.getters.currentReactivationCampaignEmailBlueprints.filter((email: IEmailBlueprint) => !email.delete);
    },
  },
  methods: {
    selectEmail(email: IEmailBlueprint): void {
      this.$store.commit(SET_CURRENT_REACTIVATION_EMAIL_BLUEPRINT_ID, email.guid);
    },
    addEmail(): void {
      this.$emit('addEmail');
      this.$nextTick(() => {
        const bottom = this.$refs.listBottom as HTMLElement;
        bottom.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
      });
    },
  },
});
